import { Button, Grid } from '@mui/material';
import { useContext } from 'react';
import PageLayout from '../../components/common/page-layout';
import RegisterInventoryRecordForm from '../../components/forms/register-inventory-record-form';
import { ModalContext } from '../../contexts/modal';

export default function PartDetails() {
  const { setOpen, setContent, setTitle } = useContext(ModalContext);

  function openLabelingModal() {
    setContent(<RegisterInventoryRecordForm onClose={() => setOpen(false)} />);
    setTitle('');
    setOpen(true);
  }

  return (
    <PageLayout pageTitle="مدیریت پارت‌ها">
      <Grid container gap={3}>
        <Grid>
          <Button variant="contained" onClick={openLabelingModal}>
            ثبت دستگاه جدید
          </Button>
        </Grid>
        <Grid>
          <Button variant="contained" onClick={openLabelingModal}>
            چاپ لیبل
          </Button>
        </Grid>
      </Grid>
    </PageLayout>
  );
}
